<template>
  <b-container>
    <b-form @submit="onSubmit">
      <div v-if="success" class="pt-4">
        <b-alert show variant="success">
          <p>{{ $t("info.successgeneric") }}</p>
        </b-alert>
      </div>
      <div v-else>
        <b-row>
          <b-col sm="6">
            <div class="mt-4">
              <strong>{{ $t("label.taskTitle") }}</strong>
            </div>
            <b-form-input v-model.trim="$v.form.taskTitle.$model" :placeholder="$t('label.taskTitle')"></b-form-input>
            <div class="text-danger" v-if="!$v.form.taskTitle.required && $v.form.taskTitle.$dirty">
              {{ $t("info.required") }}
            </div>
          </b-col>
          <b-col sm="6">
            <div class="mt-4">
              <strong>{{ $t("label.dueDateTime") }}</strong>
            </div>
            <datepicker input-class="datepicker" v-model="form.dueDateTime" :placeholder="$t('action.chooseDate')"
              :language="language" :disabledDates="disabledDate"></datepicker>

            <div class="text-danger" v-if="!$v.form.dueDateTime.required && $v.form.dueDateTime.$dirty">
              {{ $t("info.required") }}
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="6">
            <div class="mt-4">
              <strong>{{ $t("label.bucketList") }}</strong>
            </div>
            <b-form-select v-model="form.bucketSelect" :options="bucketList">
            </b-form-select>
          </b-col>
          <b-col sm="6">
            <div class="mt-4">
              <strong>{{ $t("label.priorityLevel") }}</strong>
            </div>
            <b-form-select v-model="form.priority" :options="priorityList">
            </b-form-select>
            <div class="text-danger" v-if="!$v.form.priority.required && $v.form.priority.$dirty">
              {{ $t("info.required") }}
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="6">
            <div class="mt-4">
              <strong>{{ $t("label.labelList") }}</strong>
            </div>
            <b-form-select v-model="form.labelSelect" :options="labelList" multiple size="sm"></b-form-select>
            <div>
              <small>&#9432; {{ $t("info.chooseMultiple") }}</small>
            </div>
          </b-col>
        </b-row>

        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-1 variant="info">{{
              $t("info.groupSelectForTaskAssignment")
            }}</b-button>
          </b-card-header>
          <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <ul>
                <li v-for="group in teamSelect" :key="group.Id">
                  {{ group.GroupName }}
                  <ul v-if="group.members">
                    <li>{{ group.members }}</li>
                  </ul>
                </li>
              </ul>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-button class="mt-4 text-center" type="submit" variant="success" :disabled="disabled">{{ $t("action.confirmed")
        }}</b-button>

        <div v-if="errorList.length > 0" class="pt-4">
          <b-alert show variant="danger">
            <p>{{ errorList }}</p>
          </b-alert>
        </div>
      </div>
    </b-form>
    <div v-if="spinner" class="text-center">
      <b-spinner style="width: 3rem; height: 3rem" variant="success" label="Spinning" disabled="labelStatus"></b-spinner>
    </div>
  </b-container>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import { en, fr } from "vuejs-datepicker/dist/locale";
import { required } from "vuelidate/lib/validators";

import { globalF } from "../../Helpers";

export default {
  mixins: [globalF],
  props: ["teamSelect", "modalid"],
  data: () => ({
    form: {
      taskTitle: "",
      dueDateTime: "",
      priority: null,
      bucketSelect: null,
      labelSelect: [],
    },
    groupList: [],
    disabled: false,
    success: false,
    error: "",
    spinner: false,
    errorList: [],
  }),
  validations() {
    let form = {
      taskTitle: {
        required,
      },
      dueDateTime: {
        required,
      },
      priority: {
        required,
      },
    };

    return { form };
  },
  mounted() {
    //this.getGroupList();
  },
  computed: {
    user: function () {
      return this.$store.getters.getUser;
    },
    url: function () {
      let urls = this.$store.getters.getUrlsList;
      return urls[process.env.VUE_APP_WHERE].json;
    },
    language: function () {
      return this.$i18n.locale === "fr" ? fr : en;
    },
    disabledDate: function () {
      let myDate = moment().startOf("day").toDate();
      return { to: myDate };
    },
    priorityList: function () {
      return this.$t("info.taskPriority");
    },
    bucketList: function () {
      let plannerBucket = this.getGlobalData("plannerBucket");
      let lg = this.$i18n.locale;

      let bucketList = plannerBucket.map((p) => {
        let appLg = lg === "fr" ? p.fr : p.en;
        return { value: p.Id, text: appLg };
      });
      bucketList.unshift({
        value: null,
        text: this.$t("action.chooseBucket"),
      });
      return bucketList;
    },
    labelList: function () {
      let plannerLabel = this.getGlobalData("plannerLabel");
      let lg = this.$i18n.locale;

      let labelList = plannerLabel.map((p) => {
        let appLg = lg === "fr" ? p.fr : p.en;
        return { value: p.value, text: appLg };
      });
      return labelList;
    },
  },
  methods: {
    //BUILD GROUP WITH PLAN AND BUCKET
    getGroupList() {
      this.spinner = true;
      let teamSelect = this.teamSelect;
      let token = this.getGlobalData("accessToken");
      let requestMemberOf = [];
      let requestPlans = [];
      let requestBuckets = [];
      let planId = null;

      for (let i = 0; i < teamSelect.length; i++) {
        let groupId = teamSelect[i].GroupId;
        requestPlans.push(this.getGroupPlan(token, groupId));
      }

      //get plans of Group
      Promise.allSettled(requestPlans).then((results) => {
        //set plans group
        teamSelect = this.setGroupPlan(results, teamSelect);

        for (let i = 0; i < teamSelect.length; i++) {
          let groupId = teamSelect[i].GroupId;
          requestMemberOf.push(this.getMemberOf(token, groupId));
        }

        //get plan details
        Promise.allSettled(requestMemberOf).then((results) => {
          //set plan details
          teamSelect = this.setMemberOf(results, teamSelect);

          for (let i = 0; i < teamSelect.length; i++) {
            let plansOfGroup = teamSelect[i].plansOfGroup;
            let plan = plansOfGroup[0];
            planId = plan.id;
            requestBuckets.push(this.getPlanBuckets(token, planId));
          }

          Promise.allSettled(requestBuckets).then((results) => {
            //set plan bucket
            teamSelect = this.setPlanBucket(results, teamSelect);

            //set group list
            if (this.errorList.length > 0) {
              this.error = this.errorList;
            } else {
              this.groupList = teamSelect;
            }

            this.spinner = false;
          });
        });
      });
    },
    getGroupPlan(token, groupId) {
      let graphEndpoint = `https://graph.microsoft.com/v1.0/groups/${groupId}/planner/plans`;
      return axios.get(graphEndpoint, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
    },
    setGroupPlan(results, teamSelect) {
      let successList = results.filter((r) => r.status === "fulfilled");
      if (successList.length > 0) {
        for (let i = 0; i < teamSelect.length; i++) {
          let plansOfGroup = successList[i].value.data.value;
          teamSelect[i].plansOfGroup = plansOfGroup;
        }
      }
      let errorList = results.filter((r) => r.status === "rejected");
      if (errorList.length > 0) {
        this.errorList.push(errorList);
        this.logError(errorList);
      }
      return teamSelect;
    },
    getMemberOf(token, groupId) {
      let graphEndpoint = `https://graph.microsoft.com/v1.0/groups/${groupId}/members`;
      return axios.get(graphEndpoint, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          ConsistencyLevel: "eventual",
        },
      });
    },
    setMemberOf(results, teamSelect) {
      let successList = results.filter((r) => r.status === "fulfilled");
      if (successList.length > 0) {
        for (let i = 0; i < teamSelect.length; i++) {
          let memberOfGroup = successList[i].value.data.value;
          teamSelect[i].memberSelect = [];
          teamSelect[i].memberOfGroup = memberOfGroup;
        }
      }
      let errorList = results.filter((r) => r.status === "rejected");
      if (errorList.length > 0) {
        this.errorList.push(errorList);
        this.logError(errorList);
      }
      return teamSelect;
    },
    getPlanBuckets(token, planId) {
      let graphEndpoint = `https://graph.microsoft.com/v1.0/planner/plans/${planId}/buckets`;
      return axios.get(graphEndpoint, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
    },
    setPlanBucket(results, teamSelect) {
      let successList = results.filter((r) => r.status === "fulfilled");

      if (successList.length > 0) {
        for (let i = 0; i < teamSelect.length; i++) {
          let bucketOfPlans = successList[i].value.data.value;
          //teamSelect[i].bucketSelect = null; //bucketOfPlans[0].id;
          teamSelect[i].bucketOfPlans = bucketOfPlans;
          //teamSelect[i].labelSelect = null;
        }
      }

      let errorList = results.filter((r) => r.status === "rejected");
      if (errorList.length > 0) {
        this.errorList.push(errorList);
        this.logError(errorList);
      }
      return teamSelect;
    },
    setMemberOfGroupSelect(list) {
      let memberOf = list.map((item) => {
        return {
          value: item.id,
          text: item.displayName,
        };
      });
      return memberOf;
    },
    //Set bucket b-form-select
    setBucket(list) {
      let bucketList = list.map((item) => {
        return {
          value: item.id,
          text: item.name,
        };
      });

      bucketList.unshift({
        value: null,
        text: this.$t("action.chooseBucket"),
      });

      return bucketList;
    },
    //CREATE TASK AND LOG
    onSubmit(evt) {
      evt.preventDefault();
      this.error = "";
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.spinner = true;
        this.disabled = true;
        let jobData = [];
        let groupList = this.teamSelect;

        for (let i = 0; i < groupList.length; i++) {
          let membersAssignToTask = this.getMemberAssignToTask(
            groupList[i].membersList
          );

          let bucketSelect = this.getBucketSelect(groupList[i].Language);

          let body = {
            title: this.form.taskTitle,
            priority: this.form.priority,
            assignments: membersAssignToTask,
            appliedCategories: this.getLabelCategory(),
            idGroupBuilding: groupList[i].Id,
            groupId: groupList[i].GroupId,
            bucketSelect: bucketSelect,
            planId: groupList[i].PlanId,
          };

          if (this.form.dueDateTime) {
            body.dueDateTime = moment.utc(this.form.dueDateTime).format();
          }

          jobData.push(body);
        }

        let scheduleJobObj = {
          request: "startTaskJob",
          jobName: "TaskAssignment",
          idRef: 0,
          jobDataLength: jobData.length,
          jobData: jobData,
          taskTitle: this.form.taskTitle,
          dueDateTime: this.form.dueDateTime,
          priority: this.form.priority,
          destination: this.getDestinationByUserRole(this.user.role),
          user: this.user
        };

        axios
          .post(this.url, scheduleJobObj, {
            headers: { "Content-Type": "application/json" },
          })
          .then(() => {
            this.success = true;
            this.spinner = false;
          })
          .catch(() => {
            this.spinner = false;
            this.error = this.$t("info.errorgeneric");
          });
      }
    },
    getBucketSelect(language) {
      let bucketSelect = this.form.bucketSelect;
      let plannerBucket = this.getGlobalData("plannerBucket");
      let bucketObj = plannerBucket.find((b) => b.Id === bucketSelect);
      return language === 'fr' ? bucketObj.fr : bucketObj.en;
    },
    getMemberAssignToTask(memberSelect) {
      let assignments = {};

      if (memberSelect.length > 0) {
        for (let i = 0; i < memberSelect.length; i++) {
          Object.assign(assignments, {
            [memberSelect[i].id]: {
              "@odata.type": "#microsoft.graph.plannerAssignment",
              orderHint: " !",
            },
          });
        }
      }
      else {
        assignments = null;
      }

      return assignments;
    },
    getLabelCategory() {
      let labelSelect = this.form.labelSelect;
      let returnVal = null;
      if (labelSelect.length > 0) {
        let labelCategory = {};
        for (let i = 0; i < labelSelect.length; i++) {
          Object.assign(labelCategory, {
            [labelSelect[i]]: true,
          });
        }
        returnVal = labelCategory;
      }
      return returnVal;
    },
    getBucketId(bucketOfPlans) {
      let bucketId = bucketOfPlans[0].id;
      let bucketSelect = this.form.bucketSelect;
      let find = bucketOfPlans.find(
        (b) => b.name.replace(/\W/gi, "").toLowerCase() === bucketSelect
      );
      if (find) {
        bucketId = find.id;
      }
      return bucketId;
    },
    createTask(token, body) {
      let graphEndpoint = `https://graph.microsoft.com/v1.0/planner/tasks`;
      return axios.post(graphEndpoint, body, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
    },
    logError(errorList) {
      let obj = {
        request: "logError",
        jobName: "ConfirmedTaskAssignment",
        errorList: errorList,
      };
      axios
        .post(this.url, obj, {
          headers: { "Content-Type": "application/json" },
        })
        .then(() => {
          this.spinner = false;
        })
        .catch(() => {
          this.spinner = false;
          this.error = this.$t("info.errorgeneric");
        });
    },
  },
  components: {
    Datepicker,
  },
};
</script>
